import { useCallback } from 'react';
import uniq from '@core/lodash/uniq';
import { pruneNilValues } from '@core/object';
import { sendPixelTrackingWithSession } from '@core/tracking';
import { getPlayTrigger, PlayTriggersEnum, } from '@core/tracking/playTriggerTracking';
import { useEmbedFeedStore } from '@core/widgets/embedFeed/store';
import { useStore } from '@core/widgets/store';
import { FEED_CLICK_VIDEO } from '@core/widgets/tracking';
import { customEmbedEvent, EventType } from '@embed/customEmbedEvent';
import { filterCurrentInViewport, sortByOtherArray } from '@embed/tools/utils';
import { useTracking } from './useTracking';
/**
 * Sends embed video click event.
 */
export const useTrackEmbedVideoClick = () => {
    const { params, pixelTrackingData } = useTracking();
    const navigation = useStore((state) => state.navigation);
    const inViewportIds = useEmbedFeedStore((state) => state.inViewportIds);
    return useCallback((video) => {
        const viewportVideoIds = sortByOtherArray(uniq([...filterCurrentInViewport(inViewportIds), video.encoded_id]), navigation);
        const pixelData = {
            event_properties: pruneNilValues({
                ad_id: video.ad_id,
                autoplay: params.autoplay,
                canonical_url: video.canonical_url,
                play_trigger: getPlayTrigger(params.widget_id, video.encoded_id) ||
                    PlayTriggersEnum.PLAY_TRIGGER_CLICK,
                variant: video.variant,
                _video_id: video.encoded_id,
                _live_stream_id: video.live_stream_id,
                live_stream_status: video.live_stream_status,
                _viewport_video_ids: viewportVideoIds,
                ...pixelTrackingData,
            }),
        };
        sendPixelTrackingWithSession({
            endpoint: FEED_CLICK_VIDEO,
            data: pixelData,
            host: params.api_host_tracking,
        });
        customEmbedEvent({
            type: EventType.FW_VIDEO_CLICK_VIDEO,
            params,
            data: { video },
        });
    }, [inViewportIds, navigation, params, pixelTrackingData]);
};
